<script>
export default {
    data() {
        return {
            pendingLoading: false,
            pendingData: [],
            approvedLoading: false,
            approvedData: [],
            filterPending: "",
            perPagePending: 10,
            currentPendingPage: 1,
            filterApproved: "",
            perPageApproved: 10,
            currentApprovedPage: 1,
            selectedIndex: null,
            pageOptions: [10, 25, 50, 100],
            uploadOptions: {
                type: "Purchase Request",
                placement: "lefttop",
                folder: "Procurement",
            },
            approvedLoaded: false,
        };
    },
    computed: {
        filteredPending() {
            let data = this.pendingData;
            var total = this.currentPendingPage * this.perPagePending;
            if (this.filterPending.trim() != "" && this.filterPending) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterPending.toUpperCase());
                });
            }
            data = data.slice(total - this.perPagePending, total);
            return data;
        },
        pendingRows() {
            if (this.filterPending.trim() != "" && this.filterPending) {
                let data = this.pendingData;
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterPending.toUpperCase());
                });
                return data.length;
            }
            return this.pendingData.length;
        },
        filteredApproved() {
            let data = this.approvedData;
            var total = this.currentApprovedPage * this.perPageApproved;
            if (this.filterApproved.trim() != "" && this.filterApproved) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterApproved.toUpperCase());
                });
            }
            data = data.slice(total - this.perPageApproved, total);
            return data;
        },
        approvedRows() {
            if (this.filterApproved.trim() != "" && this.filterApproved) {
                let data = this.approvedData;
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterApproved.toUpperCase());
                });
                return data.length;
            }
            return this.approvedData.length;
        },
    },
    methods: {
        async getPendingData() {
            if (this.pendingData.length == 0) {
                this.pendingLoading = true;
                await this.$store
                    .dispatch("prresolutionmember/GetPendingResolution")
                    .then((response) => {
                        response.data.map((item) => {
                            item.submitted = false;
                            item.modeOfProcurementId = "";
                            item.showPV = false;
                            item.showDetails = false;
                            item.detailLoaded = false;
                            item.loadingDetail = false;
                            item.itemVisible = false;
                            item.attachmentVisible = false;
                            item.addDocu = false;
                            item.attachmentLoading = false;
                            item.fileSearch = "";
                            item.prFiles = [];
                            item.searchKey = `${item.prResolution.pr.description} ${item.prResolution.pr.prNumber}`;
                            item.detailVisible = true;
                            item.submitDetail = false;
                            item.prResolution.pr.prItems = [];
                            item.memberVisible = false;
                            item.memberLoading = false;
                            item.prResolutionMembers = [];
                        });
                        this.pendingData = response.data;
                        this.$emit('countPending', this.pendingData.length)
                    })
                    .catch((error) => {
                        this.showToast(
                            "Something went wrong! - getting PR Items",
                            "error"
                        );
                    });
                this.pendingLoading = false;
            }
        },
        async getApprovedData() {
            if (!this.approvedLoaded) {
                this.approvedLoading = true;
                await this.$store
                    .dispatch("prresolutionmember/GetApprovedResolution")
                    .then((response) => {
                        response.data.map((item) => {
                            item.submitted = false;
                            item.modeOfProcurementId = "";
                            item.showPV = false;
                            item.showDetails = false;
                            item.detailLoaded = false;
                            item.loadingDetail = false;
                            item.itemVisible = false;
                            item.attachmentVisible = false;
                            item.addDocu = false;
                            item.attachmentLoading = false;
                            item.fileSearch = "";
                            item.prFiles = [];
                            item.searchKey = `${item.prResolution.pr.description} ${item.prResolution.pr.prNumber}`;
                            item.detailVisible = true;
                            item.submitDetail = false;
                            item.prResolution.pr.prItems = [];
                            item.memberVisible = false;
                            item.memberLoading = false;
                            item.prResolutionMembers = [];
                        });
                        this.approvedData = response.data;
                    })
                    .catch((error) => {
                        this.showToast(
                            "Something went wrong! - getting PR Items",
                            "error"
                        );
                    });
                this.approvedLoading = false;
                this.approvedLoaded = true;
            }
        },
        searchDocu(row) {
            let data = row.prFiles;
            if (row.fileSearch.trim() != "" && row.fileSearch) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(row.fileSearch.toUpperCase());
                });
            }
            return data;
        },
        getPRLogs(id) {
            this.$emit("getPrLogs", id);
        },
        showDtls(row) {
            row.itemVisible = !row.itemVisible;
            if (row.itemVisible) {
                this.getPRItems(row);
            }
        },
        getPRItems(row) {
            if (!row.detailLoaded) {
                row.prResolution.pr.prItems = [];
                row.loadingDetail = true;
                this.$store
                    .dispatch("prresolution/GetPRResolutionItems", row.prResolutionId)
                    .then((res) => {
                        row.prResolution.pr.prItems = res.data;
                        row.detailLoaded = true;
                        row.loadingDetail = false;
                    })
                    .catch((err) => {
                        this.approvedBusy = false;
                        this.showToast(
                            "Something went wrong! - getting PR Items",
                            "error"
                        );
                    });
            }
        },
        getTotalPerPR(prItems) {
            return prItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.total);
            }, 0);
        },
        getAttachments(row) {
            row.attachmentVisible = !row.attachmentVisible;
            if (row.attachmentVisible) {
                row.prFiles = [];
                row.fileSearch = "";
                row.attachmentLoading = true;
                this.$store
                    .dispatch("filemanager/GetFiles", {
                        id: row.prResolution.pr.id,
                        type: this.uploadOptions.type,
                    })
                    .then((res) => {
                        row.attachmentLoading = false;
                        row.prFiles = res.data;
                    })
                    .catch(() => {
                        row.attachmentLoading = false;
                        this.showToast(
                            "Something went wrong! - getting documents",
                            "error"
                        );
                    });
            }
        },
        approvePR(row) {
            this.$emit("approvePr", {row: row, type: 'pr'});
        },
        approvedDone(id){
            let index = this.pendingData.findIndex(x => x.id == id);
            this.approvedData.push(this.pendingData[index]);
            this.pendingData.splice(index, 1);
            let dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
            dashboardData.needBacApproval = dashboardData.needBacApproval - 1;
            localStorage.setItem("dashboardData", JSON.stringify(dashboardData));
            this.attachedDUNotifications();
            this.$emit('countPending', this.pendingData.length)
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        async printBacRes(id){
            this.$emit('printBacRes', id);
        },
        async getBACMembers(row){
            row.memberVisible = !row.memberVisible;
            if(row.memberVisible){
                row.memberLoading = true;
                await this.$store.dispatch('prresolutionmember/GetResolutionMembers', row.prResolution.id).then(res => {
                    row.prResolutionMembers = res.data;
                })
                .catch(err => {
                    this.showToast('Something went wrong!', 'error')
                })
                row.memberLoading = false;
            }
        }
    },
};
</script>
<template>
    <div>
        <b-tabs
            pills
            vertical
            nav-class="p-0"
            nav-wrapper-class="col-sm-2"
            content-class="pt-0 px-2 text-muted"
        >
            <b-tab @click="getPendingData">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Pending</span>
                </template>
                <div class="card">
                    <div class="card-body bg-primary bg-soft">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                                mb-3
                            "
                        >
                            <div>
                                <h4 class="card-title mb-0">
                                    Pending BAC Resolution(s)
                                </h4>
                                <p class="card-title-desc mb-0">
                                    List of pending BAC Resolution(s)
                                </p>
                            </div>
                            <div v-if="pendingData.length > 0">
                                <input
                                    autocomplete="off"
                                    id="name"
                                    type="text"
                                    v-model="filterPending"
                                    placeholder="Search BAC Resolution..."
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div v-if="pendingLoading" class="text-center">
                            <div
                                class="
                                    d-flex
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <div class="preloader-component me-2">
                                    <div class="status">
                                        <div
                                            class="spinner-chase w-20px h-20px"
                                        >
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                        </div>
                                    </div>
                                </div>
                                <strong>Loading...</strong>
                            </div>
                        </div>
                        <div
                            v-if="!pendingLoading && pendingData.length == 0"
                            class="text-center"
                        >
                            <h5>No data available</h5>
                        </div>
                        <div
                            v-if="
                                !pendingLoading &&
                                filterPending &&
                                filteredPending.length == 0
                            "
                            class="text-center"
                        >
                            <h5>Search not found</h5>
                        </div>
                        <div v-if="!pendingLoading && pendingData.length > 0">
                            <div
                                role="tablist"
                                v-for="x in filteredPending"
                                :key="x.id"
                            >
                                <b-card no-body class="mb-1 shadow-none">
                                    <b-card-header
                                        header-tag="header"
                                        role="tab"
                                        header-class="cursor-pointer"
                                        @click="x.showDetails = !x.showDetails"
                                    >
                                        <div
                                            class="
                                                d-flex
                                                justify-content-between
                                                align-items-center
                                            "
                                        >
                                            <div>
                                                <h6 class="mb-1">
                                                    <a
                                                        class="text-dark"
                                                        href="javascript: void(0);"
                                                        >[{{
                                                            x.prResolution.pr.prNumber
                                                        }}]:&nbsp;{{
                                                            x.prResolution.pr.description
                                                        }}</a
                                                    >
                                                </h6>
                                                <small class="text-warning">
                                                    Sign as
                                                    {{ x.position }} 
                                                    <span v-if="x.prResolution.resolutionNumber">to BAC Res No.: {{x.prResolution.resolutionNumber}}</span>
                                                </small>
                                                <span class="mx-1">|</span>
                                                <small class="text-green">
                                                    Posted on
                                                    {{ formatDate(new Date(x.prResolution.pr.datePosted)) }} ({{diffDate(x.prResolution.pr.datePosted, getDate(new Date()))}}) 
                                                </small>
                                            </div>
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                "
                                            >
                                                <div>
                                                    <span
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                        "
                                                        ><small
                                                            v-if="
                                                                !x.showDetails
                                                            "
                                                            >Click here to
                                                            expand</small
                                                        ><i
                                                            class="
                                                                bx
                                                                bx-chevron-right
                                                                rotate
                                                                font-size-18
                                                                ms-3
                                                            "
                                                            :class="{
                                                                'rotate-90':
                                                                    x.showDetails,
                                                            }"
                                                        ></i
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card-header>
                                    <b-collapse
                                        :visible="x.showDetails"
                                        :accordion="`pending-accordion-${x.id}`"
                                        role="tabpanel"
                                    >
                                        <b-card-body class="border">
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="x.detailVisible = !x.detailVisible"
                                            >
                                                <div>
                                                    <h5 class="mb-0 text-info">
                                                        <i
                                                            class="
                                                                bx bx-receipt

                                                            "
                                                        ></i>
                                                        PR
                                                        Details
                                                    </h5>
                                                </div>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.detailVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.detailVisible"
                                                :accordion="`pending-details-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <div class="row mb-2">
                                                    <div class="col-md-4">
                                                        <label for="">Mode of Procurement</label>
                                                        <div class="form-control text-warning">
                                                            {{x.prResolution.pr.modeOfProcurement ? x.prResolution.pr.modeOfProcurement.name : 'Not set'}}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <label for="">BAC Resolution Number</label>
                                                        <div class="form-control text-warning">{{x.prResolution.resolutionNumber}}</div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <label for="">Delivery Terms</label>
                                                        <div class="form-control text-warning">{{x.prResolution.pr.deliveryTerms  ? x.prResolution.pr.deliveryTerms : 'Not Set'}}</div>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <label for="">Delivery Period</label>
                                                        <div class="form-control text-warning"> {{x.prResolution.pr.deliveryPeriod}} calendar day(s)</div>
                                                    </div>
                                                </div>
                                                <div class="row mb-3">
                                                    <div class="col-md-3">
                                                        <label for="">Delivery Location</label>
                                                        <div class="form-control text-warning">{{x.prResolution.pr.deliveryLocation}}</div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label for="">Payment Terms</label>
                                                        <div class="form-control text-warning">{{x.prResolution.pr.paymentTerms ? x.prResolution.pr.paymentTerms : 'Not Set'}}</div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label for="">End User</label>
                                                        <div class="form-control text-warning">{{x.prResolution.pr.endUser.completeName}}</div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label for="">End User Position</label>
                                                        <div class="form-control text-warning">{{x.prResolution.pr.endUser.position}}</div>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                            <hr>
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="showDtls(x)"
                                            >
                                                <h5 class="mb-0 text-green">
                                                    <i
                                                        class="
                                                            bx bx-menu-alt-right
                                                        "
                                                    ></i>
                                                    PR Items <span v-if="x.itemVisible && !x.loadingDetail">({{x.prResolution.pr.prItems.length}})</span>
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.itemVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.itemVisible"
                                                :accordion="`pending-item-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <div
                                                    class="
                                                        d-flex
                                                        justify-content-center
                                                        align-items-center
                                                    "
                                                    v-if="x.loadingDetail"
                                                >
                                                    <div
                                                        class="
                                                            preloader-component
                                                            me-2
                                                        "
                                                    >
                                                        <div class="status">
                                                            <div
                                                                class="
                                                                    spinner-chase
                                                                    w-20px
                                                                    h-20px
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <strong>Loading...</strong>
                                                </div>
                                                <div
                                                    v-if="
                                                        !x.loadingDetail &&
                                                        x.prResolution.pr.prItems.length == 0
                                                    "
                                                    class="text-center"
                                                >
                                                    No items found
                                                </div>
                                                <template 
                                                    v-if="
                                                        !x.loadingDetail &&
                                                        x.prResolution.pr.prItems.length > 0
                                                    "
                                                >
                                                    <template v-for="(y, yIndex) in x.prResolution.pr.prItems">
                                                        <div
                                                            class="
                                                                ms-3
                                                                mb-1
                                                                p-3
                                                                broken-border
                                                                position-relative
                                                            "
                                                            :key="y.id"
                                                        >
                                                            <div class="d-flex align-items-center bg-success position-absolute justify-content-center p-1" style="min-width:30px;left:-30px;top:50%;transform:translateY(-50%)">
                                                                <h5 class="mb-0">{{yIndex + 1}}</h5>
                                                            </div>
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                    justify-content-between
                                                                "
                                                            >
                                                                <div class="d-flex">
                                                                    <div
                                                                        class="
                                                                            d-flex
                                                                            align-items-center
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                font-size-20
                                                                                text-yellow
                                                                            "
                                                                        >
                                                                            {{
                                                                                y.totalQuantity
                                                                            }}
                                                                        </div>
                                                                        <i
                                                                            class="
                                                                                bx bx-x
                                                                                font-size-20
                                                                                me-2
                                                                                text-yellow
                                                                            "
                                                                        ></i>
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            {{y.apiResource.itemName}}
                                                                            <div>
                                                                                <small
                                                                                    >{{y.apiResource.description}}</small
                                                                                >
                                                                                <small>
                                                                                    <span class="text-warning ms-1" v-if="y.apiResource.isProcurable">[Procurable]</span>
                                                                                    <span class="text-warning ms-1" v-else>[{{y.apiResource.isMixed ? 'Mixed' : 'Non-procurable' }}]</span>
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="text-center"
                                                                >
                                                                    <div
                                                                        class="
                                                                            font-size-20
                                                                            text-yellow
                                                                            mb-0
                                                                        "
                                                                    >
                                                                        {{formatCurrency(y.total)}}
                                                                    </div>
                                                                    <div>
                                                                        <small>
                                                                            ({{formatCurrency(y.apiResource.unitCost)}})
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="getBACMembers(x)"
                                            >
                                                <div>
                                                    <h5 class="mb-0 text-primary d-flex align-items-center">
                                                        <i
                                                            class="
                                                                bx bx-user-check font-size-18 me-1
                                                            "
                                                        ></i>
                                                        BAC Resolution Members
                                                    </h5>
                                                </div>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.memberVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.memberVisible"
                                                :accordion="`approved-member-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <template v-if="!x.memberLoading && x.prResolutionMembers && x.prResolutionMembers.length == 0">
                                                    <h4 class="text-center">No data found...</h4>
                                                </template>
                                                <template v-if="x.memberLoading">
                                                    <div class="text-center">
                                                        <div class="preloader-component me-2">
                                                            <div class="status">
                                                                <div class="spinner-chase w-20px h-20px">
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <strong>Loading...</strong>
                                                    </div>
                                                </template>
                                                <template v-if="!x.memberLoading && x.prResolutionMembers && x.prResolutionMembers.length > 0">
                                                    <template v-for="y in x.prResolutionMembers">
                                                        <div
                                                            class="
                                                                ms-3
                                                                mb-1
                                                                p-3
                                                                broken-border
                                                            "
                                                            :class="{
                                                                'broken-border-success': y.status.toUpperCase() !== 'PENDING'
                                                            }"
                                                            :key="y.id"
                                                            v-if="y"
                                                        >
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                    justify-content-between
                                                                "
                                                            >
                                                                <div>
                                                                    <span class="font-weight-bold text-white" v-if="y.applicationUser">{{y.applicationUser.completeName}}</span>
                                                                    <div>
                                                                        <small
                                                                            >{{y.bacName}} {{y.position}}</small
                                                                        >
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="text-center font-weight-bold font-size-18"
                                                                    :class="{
                                                                        'text-warning': y.status.toUpperCase() === 'PENDING',
                                                                        'text-green': y.status.toUpperCase() !== 'PENDING'
                                                                    }"
                                                                >
                                                                        {{y.status.toUpperCase() === 'APPROVED' ? 'DIGITALLY SIGNED': 'PENDING'}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="getAttachments(x)"
                                            >
                                                <h5 class="mb-0 text-warning">
                                                    <i
                                                        class="
                                                            bx bx-paperclip
                                                            rotate rotate-90
                                                        "
                                                    ></i>
                                                    Attachments
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.attachmentVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.attachmentVisible"
                                                :accordion="`pending-attachment-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <div
                                                    class="
                                                        d-flex
                                                        align-items-center
                                                        justify-content-between
                                                        mb-3
                                                    "
                                                >
                                                    <div class="d-flex">
                                                        <p
                                                            class="mb-0"
                                                            v-if="!x.attachmentLoading &&
                                                                x.prFiles
                                                                    .length == 0
                                                            "
                                                        >
                                                            <i
                                                                >No documents
                                                                found</i
                                                            >
                                                        </p>
                                                         <p
                                                            class="mb-0"
                                                            v-if="
                                                                x.attachmentLoading
                                                            "
                                                        >
                                                            <i class="font-size-15">Loading...</i
                                                            >
                                                        </p>
                                                        <input
                                                            v-if="!x.attachmentLoading &&
                                                                x.prFiles
                                                                    .length > 0
                                                            "
                                                            type="search"
                                                            class="form-control"
                                                            v-model="
                                                                x.fileSearch
                                                            "
                                                            placeholder="Search Documents..."
                                                        />
                                                    </div>
                                                </div>
                                                <div class="mt-2">
                                                    <b-row>
                                                        <b-col
                                                            sm="3"
                                                            v-for="(
                                                                y, index
                                                            ) in searchDocu(x)"
                                                            :key="y.id"
                                                            class="mb-2"
                                                        >
                                                            <div
                                                                class="
                                                                    position-relative
                                                                    cursor-pointer
                                                                "
                                                                :style="`z-index: ${
                                                                    x.prFiles
                                                                        .length -
                                                                    index
                                                                }`"
                                                            >
                                                                <div
                                                                    class="
                                                                        border
                                                                        p-3
                                                                    "
                                                                >
                                                                    <div>
                                                                        <div
                                                                            class="
                                                                                float-end
                                                                                ms-2
                                                                            "
                                                                        >
                                                                            <b-dropdown
                                                                                id="dropdown-dropleft"
                                                                                right
                                                                                variant="link"
                                                                                toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                menu-class="dropdown-menu-end"
                                                                                no-caret
                                                                            >
                                                                                <template
                                                                                    #button-content
                                                                                >
                                                                                    <i
                                                                                        class="
                                                                                            mdi
                                                                                            mdi-dots-horizontal
                                                                                        "
                                                                                    ></i>
                                                                                </template>
                                                                                <b-dropdown-item
                                                                                    @click="
                                                                                        openDocument(
                                                                                            y
                                                                                        )
                                                                                    "
                                                                                    ><i
                                                                                        class="
                                                                                            bx
                                                                                            bx-link-external
                                                                                            me-1
                                                                                        "
                                                                                    ></i
                                                                                    >Open</b-dropdown-item
                                                                                >
                                                                            </b-dropdown>
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                avatar-xs
                                                                                me-3
                                                                                mb-2
                                                                            "
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    avatar-title
                                                                                    bg-transparent
                                                                                    rounded
                                                                                "
                                                                            >
                                                                                <i
                                                                                    v-if="
                                                                                        y.fileType.includes(
                                                                                            'image'
                                                                                        )
                                                                                    "
                                                                                    class="
                                                                                        mdi
                                                                                        mdi-image
                                                                                        font-size-24
                                                                                        text-purple
                                                                                    "
                                                                                ></i>
                                                                                <i
                                                                                    v-if="
                                                                                        y.fileType.includes(
                                                                                            'application'
                                                                                        )
                                                                                    "
                                                                                    class="
                                                                                        mdi
                                                                                        mdi-file-pdf-outline
                                                                                        font-size-24
                                                                                        text-danger
                                                                                    "
                                                                                ></i>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                d-flex
                                                                            "
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    overflow-hidden
                                                                                    me-auto
                                                                                "
                                                                            >
                                                                                <h5
                                                                                    class="
                                                                                        font-size-14
                                                                                        text-truncate
                                                                                        mb-1
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        y.description
                                                                                    }}
                                                                                </h5>
                                                                                <p
                                                                                    class="
                                                                                        text-muted
                                                                                        mb-0
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        formatDateWithTime(
                                                                                            new Date(
                                                                                                y.dateTimeUploaded
                                                                                            )
                                                                                        )
                                                                                    }}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row
                                                        v-if="
                                                            searchDocu(x)
                                                                .length == 0 &&
                                                            x.fileSearch
                                                        "
                                                    >
                                                        <b-col
                                                            >Search Not
                                                            Found</b-col
                                                        >
                                                    </b-row>
                                                </div>
                                            </b-collapse>
                                            <hr />
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <button
                                                        type="button"
                                                        class="
                                                            btn btn-info
                                                            me-2
                                                        "
                                                        @click="
                                                            getPRLogs(x.prResolution.pr.id)
                                                        "
                                                    >
                                                        <i
                                                            class="
                                                                bx
                                                                bxs-receipt
                                                                me-1
                                                            "
                                                        ></i
                                                        >PR Logs
                                                    </button>
                                                    <button type="button" class="btn btn-purple me-2" @click="printBacRes(x.prResolutionId)"><i class="bx bx-printer me-1"></i>Print BAC Res</button>
                                                    <button
                                                        type="button"
                                                        class="
                                                            btn btn-success
                                                            me-2
                                                        "
                                                        @click="approvePR(x)"
                                                    >
                                                        <i
                                                            class="
                                                                bx bx-check
                                                                me-1
                                                            "
                                                        ></i
                                                        >Sign Digitally
                                                    </button>
                                                </div>
                                            </div>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>
                        <div class="mt-4" v-if="pendingData.length > 0">
                            <div
                                class="
                                    dataTables_paginate
                                    paging_simple_numbers
                                    float-end
                                "
                            >
                                <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                    <b-pagination
                                        v-model="currentPendingPage"
                                        :total-rows="pendingRows"
                                        :per-page="perPagePending"
                                    ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab @click="getApprovedData">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Approved</span>
                </template>
                <div class="card">
                    <div class="card-body bg-primary bg-soft">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                                mb-3
                            "
                        >
                            <div>
                                <h4 class="card-title mb-0">
                                    Approved BAC Resolution(s)
                                </h4>
                                <p class="card-title-desc mb-0">
                                    List of approved BAC Resolution(s)
                                </p>
                            </div>
                            <div v-if="approvedData.length > 0">
                                <input
                                    autocomplete="off"
                                    id="name"
                                    type="text"
                                    v-model="filterApproved"
                                    placeholder="Search BAC Resolution..."
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div v-if="approvedLoading" class="text-center">
                            <div
                                class="
                                    d-flex
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <div class="preloader-component me-2">
                                    <div class="status">
                                        <div
                                            class="spinner-chase w-20px h-20px"
                                        >
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                        </div>
                                    </div>
                                </div>
                                <strong>Loading...</strong>
                            </div>
                        </div>
                        <div
                            v-if="!approvedLoading && approvedData.length == 0"
                            class="text-center"
                        >
                            <h5>No data available</h5>
                        </div>
                        <div
                            v-if="
                                !approvedLoading &&
                                filterPending &&
                                filteredApproved.length == 0
                            "
                            class="text-center"
                        >
                            <h5>Search not found</h5>
                        </div>
                        <div v-if="!approvedLoading && approvedData.length > 0">
                            <div
                                role="tablist"
                                v-for="x in filteredApproved"
                                :key="x.id"
                            >
                                <b-card no-body class="mb-1 shadow-none">
                                    <b-card-header
                                        header-tag="header"
                                        role="tab"
                                        header-class="cursor-pointer"
                                        @click="x.showDetails = !x.showDetails"
                                    >
                                        <div
                                            class="
                                                d-flex
                                                justify-content-between
                                                align-items-center
                                            "
                                        >
                                            <div>
                                                <h6 class="mb-1">
                                                    <a
                                                        class="text-dark"
                                                        href="javascript: void(0);"
                                                        >[{{
                                                            x.prResolution.pr.prNumber
                                                        }}]:&nbsp;{{
                                                            x.prResolution.pr.description
                                                        }}</a
                                                    >
                                                </h6>
                                                <small class="text-warning"
                                                    >Sign as
                                                    {{ x.position }}</small
                                                >
                                            </div>
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                "
                                            >
                                                <div>
                                                    <span
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                        "
                                                        ><small
                                                            v-if="
                                                                !x.showDetails
                                                            "
                                                            >Click here to
                                                            expand</small
                                                        ><i
                                                            class="
                                                                bx
                                                                bx-chevron-right
                                                                rotate
                                                                font-size-18
                                                                ms-3
                                                            "
                                                            :class="{
                                                                'rotate-90':
                                                                    x.showDetails,
                                                            }"
                                                        ></i
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card-header>
                                    <b-collapse
                                        :visible="x.showDetails"
                                        :accordion="`approved-accordion-${x.id}`"
                                        role="tabpanel"
                                    >
                                        <b-card-body class="border">
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="x.detailVisible = !x.detailVisible"
                                            >
                                                <div>
                                                    <h5 class="mb-0 text-info">
                                                        <i
                                                            class="
                                                                bx bx-receipt

                                                            "
                                                        ></i>
                                                        PR
                                                        Details
                                                    </h5>
                                                </div>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.detailVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.detailVisible"
                                                :accordion="`approved-details-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <div class="row mb-2">
                                                    <div class="col-md-4">
                                                        <label for="">Mode of Procurement</label>
                                                        <div class="form-control text-warning">{{x.prResolution.pr.modeOfProcurement ? x.prResolution.pr.modeOfProcurement.name : 'Not set'}}</div>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <label for="">BAC Resolution Number</label>
                                                        <div class="form-control text-warning">{{x.prResolution.resolutionNumber}}</div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <label for="">Delivery Terms</label>
                                                        <div class="form-control text-warning">{{x.prResolution.pr.deliveryTerms ? x.prResolution.pr.deliveryTerms : 'Not set'}}</div>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <label for="">Delivery Period</label>
                                                        <div class="form-control text-warning"> {{x.prResolution.pr.deliveryPeriod}} calendar day(s)</div>
                                                    </div>
                                                </div>
                                                <div class="row mb-3">
                                                    <div class="col-md-3">
                                                        <label for="">Delivery Location</label>
                                                        <div class="form-control text-warning">{{x.prResolution.pr.deliveryLocation}}</div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label for="">Payment Terms</label>
                                                        <div class="form-control text-warning">{{x.prResolution.pr.paymentTerms ? x.prResolution.pr.paymentTerms : 'Not set'}}</div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label for="">End User</label>
                                                        <div class="form-control text-warning">{{x.prResolution.pr.endUser.completeName}}</div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label for="">End User Position</label>
                                                        <div class="form-control text-warning">{{x.prResolution.pr.endUser.position}}</div>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                            <hr>
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="showDtls(x)"
                                            >
                                                <h5 class="mb-0 text-green">
                                                    <i
                                                        class="
                                                            bx bx-menu-alt-right
                                                        "
                                                    ></i>
                                                    PR Items <span v-if="x.itemVisible && !x.loadingDetail">({{x.prResolution.pr.prItems.length}})</span>
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.itemVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.itemVisible"
                                                :accordion="`approved-item-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <div
                                                    class="
                                                        d-flex
                                                        justify-content-center
                                                        align-items-center
                                                    "
                                                    v-if="x.loadingDetail"
                                                >
                                                    <div
                                                        class="
                                                            preloader-component
                                                            me-2
                                                        "
                                                    >
                                                        <div class="status">
                                                            <div
                                                                class="
                                                                    spinner-chase
                                                                    w-20px
                                                                    h-20px
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                                <div
                                                                    class="
                                                                        chase-dot
                                                                    "
                                                                ></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <strong>Loading...</strong>
                                                </div>
                                                <div
                                                    v-if="
                                                        !x.loadingDetail &&
                                                        x.prResolution.pr.prItems.length == 0
                                                    "
                                                    class="text-center"
                                                >
                                                    No items found
                                                </div>
                                                <template 
                                                    v-if="
                                                        !x.loadingDetail &&
                                                        x.prResolution.pr.prItems.length > 0
                                                    "
                                                >
                                                    <template v-for="(y, yIndex) in x.prResolution.pr.prItems">
                                                        <div
                                                            class="
                                                                ms-3
                                                                mb-1
                                                                p-3
                                                                broken-border
                                                                position-relative
                                                            "
                                                            :key="y.id"
                                                        > 
                                                            <div class="d-flex align-items-center bg-success position-absolute justify-content-center p-1" style="min-width:30px;left:-30px;top:50%;transform:translateY(-50%)">
                                                                <h5 class="mb-0">{{yIndex + 1}}</h5>
                                                            </div>
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                    justify-content-between
                                                                "
                                                            >
                                                                <div class="d-flex">
                                                                    <div
                                                                        class="
                                                                            d-flex
                                                                            align-items-center
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                font-size-20
                                                                                text-yellow
                                                                            "
                                                                        >
                                                                            {{
                                                                                y.totalQuantity
                                                                            }}
                                                                        </div>
                                                                        <i
                                                                            class="
                                                                                bx bx-x
                                                                                font-size-20
                                                                                me-2
                                                                                text-yellow
                                                                            "
                                                                        ></i>
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            {{y.apiResource.itemName}}
                                                                            <div>
                                                                                <small
                                                                                    >{{y.apiResource.description}}</small
                                                                                >
                                                                                <small>
                                                                                    <span class="text-warning ms-1" v-if="y.apiResource.isProcurable">[Procurable]</span>
                                                                                    <span class="text-warning ms-1" v-else>[{{y.apiResource.isMixed ? 'Mixed' : 'Non-procurable' }}]</span>
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="text-center"
                                                                >
                                                                    <div
                                                                        class="
                                                                            font-size-20
                                                                            text-yellow
                                                                            mb-0
                                                                        "
                                                                    >
                                                                        {{formatCurrency(y.total)}}
                                                                    </div>
                                                                    <div>
                                                                        <small>
                                                                            ({{formatCurrency(y.apiResource.unitCost)}})
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="getBACMembers(x)"
                                            >
                                                <div>
                                                    <h5 class="mb-0 text-primary d-flex align-items-center">
                                                        <i
                                                            class="
                                                                bx bx-user-check font-size-18 me-1
                                                            "
                                                        ></i>
                                                        BAC Resolution Members
                                                    </h5>
                                                </div>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.memberVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.memberVisible"
                                                :accordion="`approved-member-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <template v-if="!x.memberLoading && x.prResolutionMembers && x.prResolutionMembers.length == 0">
                                                    <h4 class="text-center">No data found...</h4>
                                                </template>
                                                <template v-if="x.memberLoading">
                                                    <div class="text-center">
                                                        <div class="preloader-component me-2">
                                                            <div class="status">
                                                                <div class="spinner-chase w-20px h-20px">
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <strong>Loading...</strong>
                                                    </div>
                                                </template>
                                                <template v-if="!x.memberLoading && x.prResolutionMembers && x.prResolutionMembers.length > 0">
                                                    <template v-for="y in x.prResolutionMembers">
                                                        <div
                                                            class="
                                                                ms-3
                                                                mb-1
                                                                p-3
                                                                broken-border
                                                            "
                                                            :class="{
                                                                'broken-border-success': y.status.toUpperCase() !== 'PENDING'
                                                            }"
                                                            :key="y.id"
                                                        >
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                    justify-content-between
                                                                "
                                                            >
                                                                <div>
                                                                    <span class="font-weight-bold text-white">{{y.applicationUser.completeName}}</span>
                                                                    <div>
                                                                        <small
                                                                            >{{y.bacName}} {{y.position}}</small
                                                                        >
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="text-center font-weight-bold font-size-18"
                                                                    :class="{
                                                                        'text-warning': y.status.toUpperCase() === 'PENDING',
                                                                        'text-green': y.status.toUpperCase() !== 'PENDING'
                                                                    }"
                                                                >
                                                                        {{y.status.toUpperCase() === 'APPROVED' ? 'DIGITALLY SIGNED': 'PENDING'}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="getAttachments(x)"
                                            >
                                                <h5 class="mb-0 text-warning">
                                                    <i
                                                        class="
                                                            bx bx-paperclip
                                                            rotate rotate-90
                                                        "
                                                    ></i>
                                                    Attachments
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.attachmentVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.attachmentVisible"
                                                :accordion="`approved-attachment-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <div
                                                    class="
                                                        d-flex
                                                        align-items-center
                                                        justify-content-between
                                                        mb-3
                                                    "
                                                >
                                                    <div class="d-flex">
                                                        <p
                                                            class="mb-0"
                                                            v-if="!x.attachmentLoading &&
                                                                x.prFiles
                                                                    .length == 0
                                                            "
                                                        >
                                                            <i
                                                                >No documents
                                                                found</i
                                                            >
                                                        </p>
                                                         <p
                                                            class="mb-0"
                                                            v-if="
                                                                x.attachmentLoading
                                                            "
                                                        >
                                                            <i class="font-size-15">Loading...</i
                                                            >
                                                        </p>
                                                        <input
                                                            v-if="
                                                                !x.attachmentLoading && x.prFiles
                                                                    .length > 0
                                                            "
                                                            type="search"
                                                            class="form-control"
                                                            v-model="
                                                                x.fileSearch
                                                            "
                                                            placeholder="Search Documents..."
                                                        />
                                                    </div>
                                                    <!-- <div class="">
                                                        <a
                                                            href="javascript:void(0);"
                                                            class="
                                                                text-primary
                                                                border-primary
                                                                border
                                                                p-2
                                                            "
                                                            :id="`pending-document${x.id}`"
                                                            @click="
                                                                x.addDocu = true
                                                            "
                                                            ><i
                                                                class="
                                                                    bx
                                                                    bx-plus
                                                                "
                                                            ></i
                                                            >Upload
                                                            Documents</a
                                                        >
                                                        <upload-popover
                                                            :option="
                                                                uploadOptions
                                                            "
                                                            :sourceId="
                                                                x.id
                                                            "
                                                            @uploaded="
                                                                uploadedPosted(
                                                                    $event,
                                                                    x.id
                                                                )
                                                            "
                                                            :showPV="
                                                                x.addDocu
                                                            "
                                                            @closePopover="
                                                                x.addDocu = false
                                                            "
                                                            :dzId="`dropzone-pending${x.id}`"
                                                            :pvId="`pending-document${x.id}`"
                                                        ></upload-popover>
                                                    </div> -->
                                                </div>
                                                <div class="mt-2">
                                                    <b-row>
                                                        <b-col
                                                            sm="3"
                                                            v-for="(
                                                                y, index
                                                            ) in searchDocu(x)"
                                                            :key="y.id"
                                                            class="mb-2"
                                                        >
                                                            <div
                                                                class="
                                                                    position-relative
                                                                    cursor-pointer
                                                                "
                                                                :style="`z-index: ${
                                                                    x.prFiles
                                                                        .length -
                                                                    index
                                                                }`"
                                                            >
                                                                <div
                                                                    class="
                                                                        border
                                                                        p-3
                                                                    "
                                                                >
                                                                    <div>
                                                                        <div
                                                                            class="
                                                                                float-end
                                                                                ms-2
                                                                            "
                                                                        >
                                                                            <b-dropdown
                                                                                id="dropdown-dropleft"
                                                                                right
                                                                                variant="link"
                                                                                toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                menu-class="dropdown-menu-end"
                                                                                no-caret
                                                                            >
                                                                                <template
                                                                                    #button-content
                                                                                >
                                                                                    <i
                                                                                        class="
                                                                                            mdi
                                                                                            mdi-dots-horizontal
                                                                                        "
                                                                                    ></i>
                                                                                </template>
                                                                                <b-dropdown-item
                                                                                    @click="
                                                                                        openDocument(
                                                                                            y
                                                                                        )
                                                                                    "
                                                                                    ><i
                                                                                        class="
                                                                                            bx
                                                                                            bx-link-external
                                                                                            me-1
                                                                                        "
                                                                                    ></i
                                                                                    >Open</b-dropdown-item
                                                                                >
                                                                            </b-dropdown>
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                avatar-xs
                                                                                me-3
                                                                                mb-2
                                                                            "
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    avatar-title
                                                                                    bg-transparent
                                                                                    rounded
                                                                                "
                                                                            >
                                                                                <i
                                                                                    v-if="
                                                                                        y.fileType.includes(
                                                                                            'image'
                                                                                        )
                                                                                    "
                                                                                    class="
                                                                                        mdi
                                                                                        mdi-image
                                                                                        font-size-24
                                                                                        text-purple
                                                                                    "
                                                                                ></i>
                                                                                <i
                                                                                    v-if="
                                                                                        y.fileType.includes(
                                                                                            'application'
                                                                                        )
                                                                                    "
                                                                                    class="
                                                                                        mdi
                                                                                        mdi-file-pdf-outline
                                                                                        font-size-24
                                                                                        text-danger
                                                                                    "
                                                                                ></i>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                d-flex
                                                                            "
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    overflow-hidden
                                                                                    me-auto
                                                                                "
                                                                            >
                                                                                <h5
                                                                                    class="
                                                                                        font-size-14
                                                                                        text-truncate
                                                                                        mb-1
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        y.description
                                                                                    }}
                                                                                </h5>
                                                                                <p
                                                                                    class="
                                                                                        text-muted
                                                                                        mb-0
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        formatDateWithTime(
                                                                                            new Date(
                                                                                                y.dateTimeUploaded
                                                                                            )
                                                                                        )
                                                                                    }}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row
                                                        v-if="
                                                            searchDocu(x)
                                                                .length == 0 &&
                                                            x.fileSearch
                                                        "
                                                    >
                                                        <b-col
                                                            >Search Not
                                                            Found</b-col
                                                        >
                                                    </b-row>
                                                </div>
                                            </b-collapse>
                                            <hr />
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <button
                                                        type="button"
                                                        class="
                                                            btn btn-info
                                                            me-2
                                                        "
                                                        @click="
                                                            getPRLogs(x.pr.id)
                                                        "
                                                    >
                                                        <i
                                                            class="
                                                                bx
                                                                bxs-receipt
                                                                me-1
                                                            "
                                                        ></i
                                                        >PR Logs
                                                    </button>
                                                    <button type="button" class="btn btn-purple me-2" @click="printBacRes(x.prResolutionId)"><i class="bx bx-printer me-1"></i>Print BAC Res</button>
                                                </div>
                                            </div>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>
                        <div class="mt-4" v-if="approvedData.length > 0">
                            <div
                                class="
                                    dataTables_paginate
                                    paging_simple_numbers
                                    float-end
                                "
                            >
                                <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                    <b-pagination
                                        v-model="currentApprovedPage"
                                        :total-rows="approvedRows"
                                        :per-page="perPageApproved"
                                    ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>